<template>
    <vx-card>
      <vs-tabs alignment="fixed" v-model="activeTabs">
        <vs-tab label="Company" @click.prevent="$router.push({name:'org_management'})">
        </vs-tab>
        <vs-tab label="Sites" @click.prevent="$router.push({name:'org_management_sites'})">
        </vs-tab>
        <vs-tab label="Area" @click.prevent="$router.push({name:'org_management_area'})">
        </vs-tab>
        <vs-tab label="Camera">
          <cameras />
        </vs-tab>
      <vs-tab label="Users" @click.prevent="$router.push({name:'org_management_users'})">
      </vs-tab>
      <!-- <vs-tab label="General" @click.prevent="$router.push({name:'org_management_general'})">
      </vs-tab> -->
      </vs-tabs>
    </vx-card>
  </template>

<script>
    import Cameras from "./lists.vue";
    
    export default {
        data() {
            return {
                activeTabs: 3
            }
        },
      components: {
        Cameras,
      },
    };
</script>    